<template>
    <div>
        <template v-for="(flag, index) in flagDisplay">
            <b-button size="sm" pill :key="index" :variant="getVariant(flag.flag_type.config)" class="ml-2 pointer"
                     @click="flagSelected(flag,index)" :title="flag.flag_type.description" v-b-tooltip>
                {{ flag.flag_type.abbreviations }}
                <span class="comment-icon-container" v-if="flag.replies && flag.replies.length > 0">
                    <i class="fa-solid fa-comment-lines comment-icon"></i>
                </span>
            </b-button>
        </template>

        <b-button size="sm" pill variant="link" class="ml-2 pointer" v-b-tooltip="'Add Flag'"
                  @click="addFlag()">
            <i class="fa-solid fa-plus text-success"></i>
        </b-button>
    </div>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'FlagListHorizontal',
    props: ['flags'],
    data() {
        return {
            flagsCopy: [],
            selectedFlag: null,
            updateLoc: -1,
            loaded: false,
        };
    },
    methods: {
        addFlag() {
            this.updateLoc = this.flagsCopy.length;
            this.$store.commit('setAddFlag', true);
        },
        flagSelected(flag, index) {
            //if(flag.flag_type.category == 'flag') { we need to access tags to clear tags.
                this.updateLoc = index;
                this.$store.commit('setActiveFlag', flag);
            //}
        },
        getVariant(config) {
            if(config) {
                let decodedConfig = JSON.parse(config);
                return decodedConfig.variant ? decodedConfig.variant : 'secondary';
            }
            return 'secondary';
        },
        updateFlag(flag){
            if(flag == null) {
                return;
            }
            let index = _.findIndex(this.flagsCopy, (e)=>{
                return e.id == flag.id;
            });
            if(index == -1){
                index = this.flagsCopy.length;
            }
            let flagsCopy2 = Object.assign([],this.flagsCopy);

            //todo I have no idea why but I must do this terriableness to update the flags, I should literally need to do this.flag[index] = flag;
            if(flag.deleted_at) {
                flagsCopy2.splice(index, 1);
            } else {
                flagsCopy2[index] = flag;
            }
            this.flagsCopy = flagsCopy2;
            this.$forceUpdate();
        }
    },
    computed: {
        _isFlagUpdated () {
            return this.$store.getters.updatedFlag;
        },
        flagDisplay() {
            return this.flagsCopy.filter(flag => flag.cleared_at == null);
        }
    },
    watch: {
        flags: {
            immediate: true,
            handler(flags)
            {
                this.flagsCopy = Object.assign([], flags)
                this.loaded = true;
            }
        },
        _isFlagUpdated: {
            immediate: true,
            deep: true,
            handler(flag) {
                if (this.loaded) {
                    this.updateFlag(flag);
                }
            }
        }
    }
};
</script>

<style scoped>
.btn-sm {
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
}

.btn-sm.rounded-pill {
    padding-right: 0.6em;
    padding-left: 0.6em;
}

.comment-icon-container {
    position: relative;
    padding-left: 3px;
}

.comment-icon {
    position: absolute;
    top: -6px;
    color: dimgrey;
}
</style>
